'use client'

import { useEffect } from 'react'
import Link from 'next/link'
import { track } from '@/lib/tracking'

export default function NotFound() {
  useEffect(() => {
    track('page_not_found', {
      attempted_url: window.location.href,
    })
  }, [])

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
      <h2 className="text-2xl font-semibold text-gray-600 mb-6">Page Not Found</h2>
      <p className="text-gray-500 mb-8 max-w-md">
        The page you are looking for doesn&apos;t exist or has been moved.
      </p>
      <Link
        href="/"
        className="bg-[#F05A24] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#F05A24]/90 transition"
      >
        Back to Home
      </Link>
    </div>
  )
}
